import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import ActionsMessagingLimitIndexController from 'cio/pods/actions/messaging-limit/index/controller';
import EnvironmentModel from 'cio/models/environment';
import Transition from '@ember/routing/-private/transition';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class ActionsMessagingLimitIndex extends Route {
  @service confirmChanges!: ConfirmChangesService;

  setupController(controller: ActionsMessagingLimitIndexController, model: EnvironmentModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setProxy();

    this.confirmChanges.register(controller, this);
  }

  resetController(controller: ActionsMessagingLimitIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
